import * as stringTemplate from './stringTemplate';
import * as validations from './validations';

export const DecapCmsLibWidgets = {
  stringTemplate,
  validations,
};
export { stringTemplate, validations };
